import capitalize from 'lodash/capitalize';
import React, { use } from 'react';

import { WebsiteLink } from 'src/components/common/website-link';
import type { BaseHeaderContent } from 'src/components/layout/redesign/header-mobile/header-menu';
import LanguageSelection from 'src/components/layout/redesign/header-shared/language-selection';
import { SiteContext } from 'src/context/site-context';
import { amplitudeLinkTrackEvent } from 'src/helpers/amplitude-event-track';

import * as styles from './header-secondary-nav.module.scss';

type HeaderMobileSecondaryNavProps = {
  headerContent?: BaseHeaderContent;
  onClick?: () => void;
};

const HeaderMobileSecondaryNav: React.FC<HeaderMobileSecondaryNavProps> = ({
  headerContent,
  onClick,
}) => {
  const { pageLevel, buildType, language } = use(SiteContext);

  return (
    <div className={styles.wrapper}>
      {(headerContent?.headerSecondaryUpperMenu ?? []).map((link) => {
        const handleClick = () => {
          onClick?.();
          void amplitudeLinkTrackEvent({
            buildType,
            language,
            linkName: capitalize(link.text || ''),
            linkPath: link.link,
            linkEventName: 'Link in Navigation',
            componentName: 'Header Secondary Navigation',
            pageLevel,
          });
        };

        return (
          <WebsiteLink
            key={link.text}
            to={link.link}
            goToGlobal={link.goToGlobal ?? undefined}
            handleClick={handleClick}
          >
            <div className={styles.link}>{link.text}</div>
          </WebsiteLink>
        );
      })}
      <LanguageSelection text={headerContent?.headerOtherText?.selectLanguageText} />
    </div>
  );
};

export default HeaderMobileSecondaryNav;
